import { configureStore } from '@reduxjs/toolkit'
import busyReducer from './slice/BusySlice'
import configurationReducer from './slice/ConfigurationSlice';
import userReducer from './slice/UserSlice';


export const AppStore = configureStore (
  {
    reducer : {
      user:userReducer,
      busy:busyReducer,
      configuration:configurationReducer,
    },
    middleware:( getDefaultMiddleware ) => {
      return getDefaultMiddleware( {
        serializableCheck: false
      } )
    },
    devTools: {
      serialize: {options:{map:true}}
    }
  }
)

export type AppDispatch = typeof AppStore.dispatch
export type AppState = ReturnType<typeof AppStore.getState>;
